import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as echarts from "echarts";
import strongTheme from "assets/theme/echart/strong-theme.json";
import { ReportConfig } from "container/Report/Config/ReportConfig";

echarts.registerTheme(ReportConfig.common.CHART_THEMES.STRONG, strongTheme);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// 앱의 성능을 측정하려면 결과를 기록할 함수를 전달하십시오.
// (예: reportWebVitals(console.log))
// 또는 분석 엔드포인트로 전송하십시오. 자세한 내용은 다음 링크를 참조하십시오: https://bit.ly/CRA-vitals
reportWebVitals();
